import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { dateformat } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
    selector: 'app-freeze-user-timings-dialog',
    templateUrl: './freeze-user-timings-dialog.component.html',
    styleUrls: ['./freeze-user-timings-dialog.component.scss'],
    standalone: false
})
export class FreezeUserTimingsDialogComponent {

  dataSource: any = [];
  userList: any = [];
  showData: boolean = false;
  userName: any;
  userId: any;
  dateFormat:any;
  displayedColumns: string[] = [
    'FreezeStartDate',
    'FreezeEndDate',
  ];

  constructor(
    private dialogRef: MatDialogRef<FreezeUserTimingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
  ) {
    this.userName = data.Name;
    this.userId = data.UserId
    this.dateFormat = dateformat
  }

  ngOnInit(): void {
    this.fetchFreezeCustomerTimingsList();
  }

  fetchFreezeCustomerTimingsList() {
    this.showData = false;
    let api = this.api.apiUrl.Class.GetUserFreezeTimingsList.replace('{Id}', this.userId);
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.showData = true;
          this.userList = response.data;
          this.dataSource = response.data;
          this.spinner.hide();
          if (this.userList.length != 0) {
            this.showData = false;
            this.spinner.hide();
          }
          else {
            this.showData = true;
            this.spinner.hide();
          }
        }
        else {
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }
}